import React, { useEffect, useState } from "react";
import { MapPinned, RotateCcw, Loader2 } from "lucide-react";
import api from "../../api";
import { flagFor } from "../../utils/flags";
import { useToast } from "../../hooks/use-toast";

// Where people are asking for deals we don't have yet — the door-knocking list.
export const AdminDemand = () => {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);
  const { toast } = useToast();
  useEffect(() => { api.get("/admin/demand").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return null;

  const reset = async () => {
    if (!window.confirm("Clear the whole 'Where deals are wanted' list? This can't be undone.")) return;
    setBusy(true);
    try {
      const { data } = await api.delete("/admin/demand");
      setRows([]);
      toast({ title: "List cleared", description: `${data.deleted} entr${data.deleted === 1 ? "y" : "ies"} removed.` });
    } catch { toast({ title: "Could not clear that" }); }
    finally { setBusy(false); }
  };

  return (
    <div className="bg-card border border-border rounded-2xl p-5" data-testid="admin-demand">
      <div className="flex items-start justify-between gap-3">
        <h2 className="font-bold text-foreground flex items-center gap-2">
          <MapPinned size={18} className="text-[#16a34a]" /> Where deals are wanted
        </h2>
        {rows.length > 0 && (
          <button onClick={reset} disabled={busy} data-testid="reset-demand-btn"
            className="shrink-0 inline-flex items-center gap-1.5 text-xs font-bold border border-border hover:border-red-400 hover:text-red-500 text-muted-foreground rounded-xl px-3 py-1.5 transition-colors disabled:opacity-60">
            {busy ? <Loader2 className="animate-spin" size={13} /> : <RotateCcw size={13} />} Reset
          </button>
        )}
      </div>
      <p className="text-xs text-muted-foreground mt-0.5 mb-4">
        Every time someone finds an empty map and tells us where they are. Sell into the top of this list.
      </p>
      {rows.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="admin-demand-empty">No requests yet.</p>
      ) : (
        <div className="space-y-2">
          {rows.slice(0, 12).map((r) => (
            <div key={`${r.country}-${r.place}`} className="flex items-center justify-between gap-3 bg-secondary rounded-xl px-3 py-2.5" data-testid={`demand-row-${(r.place || r.country || "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <div className="min-w-0">
                <p className="text-sm font-bold text-foreground truncate">
                  <span className="mr-1">{flagFor(r.country)}</span>{r.place || r.country}
                </p>
                <p className="text-xs text-muted-foreground truncate">
                  {r.place && r.country ? `${r.country} · ` : ""}{r.waiting} waiting for an email
                </p>
              </div>
              <span className="shrink-0 text-sm font-extrabold text-[#16a34a]">{r.asks}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminDemand;
